import {post} from './';

export const getInfoStore = (body) => {
  const url = '/api/store/get'
  return post(url, body)
}

export const getListBranchStore = (body) => {
  const url = '/api/store/list-brand'
  return post(url, body)
}

export const getListProductType = (body) => {
  const url = '/api/product-type/list'
  return post(url, body)
}

export const getListProduct = (body) => {
  const url = '/api/product/list'
  return post(url, body)
}

export const  getOrderType = (body) => {
  const url = '/api/errand/get-order-type'
  return post(url, body)
}
export const  getOrderTypeFood = (body) => {
  const url = '/api/order-type/get'
  return post(url, body)
}
export const  createOrderStore = (body) => {
  const url = '/api/order-store/create'
  return post(url, body)
}
export const getConfigCODOrder = (body) => {
  const url = '/api/order/get-config-cod'
  return post(url, body)
}
export const  getConfigErrandFee = (body) => {
  const url = '/api/store/get-config-errand-fee'
  return post(url, body)
}
export const getDistanceMoney = (body) => {
  const url = '/api/order/get-distance-money'
  return post(url, body)
}
export const getLocationName = (body) => {
  const url = '/api/order/get-location-name'
  return post(url, body)
}
export const placeAutocomplete = (body) => {
  const url = '/api/order/place-autocomplete'
  return post(url, body)
}
export const placeDetail = (body) => {
  const url = '/api/order/place-detail'
  return post(url, body)
}
export const getListForCustomer = (body) => {
  const url = '/api/order/list-for-customer'
  return post(url, body)
}
export const getForCustomer = (body) => {
  const url = '/api/order/get-for-customer'
  return post(url, body)
}
export const getTimeLine = (body) => {
  const url = '/api/order/get-time-line'
  return post(url, body)
}
export const rejectForCustomer = (body) => {
  const url = '/api/order/reject-for-customer'
  return post(url, body)
}
export const getConfigPromoteStore = (body) => {
  const url = '/api/promote/config-show-promote'
  return post(url, body)
}
export const getListPromoteShop = (body) => {
  const url = '/api/promote-shop/list'
  return post(url, body)
}
export const getCountPromoteShop = (body) => {
  const url = '/api/promote-shop/count'
  return post(url, body)
}
export const getPromoteShop = (body) => {
  const url = '/api/promote-shop/get'
  return post(url, body)
}
export const checkOutOfStock = (body) => {
  const url = '/api/product/get'
  return post(url, body)
}
export const getConfigShowContact = (body) => {
  const url = '/api/order/config-show-contact'
  return post(url, body)
}
